import React from 'react';
import { Link } from 'react-router-dom';
import useTranslation from 'utils/hooks/useTranslation';
import { Typography } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';
import useGetSupportLink from 'utils/hooks/useGetSupportLink';
import { ROUTES } from 'constants.js';

import styles from './style.module.scss';

const CreditAccountPendingBanner = () => {
  const { translateText } = useTranslation();
  const supportLink = useGetSupportLink();

  return (
    <div className={styles.pendingBannerContainer}>
      <section className={styles.pendingBannerSection}>
        <InfoCircleFilled className={styles.pendingBannerIcon} />
        <Typography>
          {translateText('corporateAccounts.creditAccount.pendingBanner.informationUpdate')}{' '}
          <a href={supportLink} target="_blank" rel="noreferrer">
            {translateText('corporateAccounts.creditAccount.pendingBanner.contactSupport')}
          </a>
          <br />
          {translateText('corporateAccounts.creditAccount.pendingBanner.startParking')}{' '}
          <Link to={ROUTES.PAYMENTS}>
            {translateText('corporateAccounts.creditAccount.pendingBanner.addCreditCard')}
          </Link>{' '}
          {translateText('corporateAccounts.creditAccount.pendingBanner.addCreditCardDescription')}
        </Typography>
      </section>
    </div>
  );
};

export default CreditAccountPendingBanner;
